import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_KEY = "cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (type) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ type, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] animate-in slide-in-from-bottom-4 duration-500"
    >
      <div className="bg-slate-900/95 backdrop-blur-lg border-t border-white/10 shadow-2xl">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-start gap-3 flex-1 min-w-0">
              <Shield className="h-5 w-5 text-[#c8e414] shrink-0 mt-0.5" />
              <div>
                <p className="text-white text-sm font-medium leading-relaxed">
                  Questo sito utilizza cookie tecnici necessari al funzionamento e cookie di terze parti per l'autenticazione e i pagamenti.
                </p>
                <p className="text-white/50 text-xs mt-1">
                  Per maggiori informazioni, consulta la nostra{" "}
                  <Link to="/cookie-policy" className="text-[#c8e414] underline underline-offset-2 hover:text-[#d4ef2f]">Cookie Policy</Link>
                  {" "}e l'{" "}
                  <Link to="/privacy-policy" className="text-[#c8e414] underline underline-offset-2 hover:text-[#d4ef2f]">Informativa Privacy</Link>.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
              <Button
                data-testid="cookie-accept-necessary"
                variant="outline"
                size="sm"
                onClick={() => accept("necessary")}
                className="flex-1 sm:flex-initial rounded-sm text-xs font-bold uppercase border-white/20 text-white hover:bg-white/10 hover:text-white bg-transparent"
              >
                Solo necessari
              </Button>
              <Button
                data-testid="cookie-accept-all"
                size="sm"
                onClick={() => accept("all")}
                className="flex-1 sm:flex-initial rounded-sm text-xs font-bold uppercase bg-[#c8e414] text-slate-900 hover:bg-[#d4ef2f]"
              >
                Accetta tutti
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
